export type InputWidgets = LabelInputWidget | TextFieldInputWidget | PhotoTakerInputWidget | PickerInputWidget | ToggleInputWidget | NumericFieldInputWidget | DateTimeFieldInputWidget;
export type DisplayWidgets = LabelDisplayWidget | TextFieldDisplayWidget | PhotoTakerDisplayWidget | DateTimeFieldDisplayWidget;

export const WIDGET_DATA_TYPE_VALUES = ["string", "integer", "decimal"];
export const NUMERIC_WIDGET_DATA_TYPE_VALUES = ["integer", "decimal"];
export const DATETIME_WIDGET_DATA_TYPE_VALUES = [
    {
        value: "datetime",
        display: "Date and Time"
    },
    {
        value: "dateonly",
        display: "Date Only"
    }
];
export const DATETIME_WIDGET_DEFAULT_TIME_VALUES = [
    {
        value: "now",
        display: "Now"
    },
    {
        value: "noonUTC",
        display: "Noon on UTC time"
    }
];
export type WIDGET_DATA_TYPE = typeof WIDGET_DATA_TYPE_VALUES[number];

export type LabelInputWidget = {
    properties: {
        align?: "center" | "left";
        color?: number[];
        size?: number;
        style?: "bold";
        text: string;
    },
    type: "label"
}

export type TextFieldInputWidget = {
    properties: {
        align?: "center" | "left",
        editable: "true",
        height?: number,
        placeholder: string,
        widget_id: string,
        input_type?: WIDGET_DATA_TYPE
    },
    type: "textfield"
}

export type PhotoTakerInputWidget = {
    properties: {
        align?: "center";
        widget_id: string;
    },
    type: "photo_taker"
}

export type PickerInputWidget = {
    properties: {
        components: 1,
        picker_values: string[],
        widget_id: string;
        input_type?: WIDGET_DATA_TYPE;
    },
    type: "picker"
}

export type ToggleInputWidget = {
    properties: {
        segment_titles: string[];
        segment_values: string[];
        selected_index: string;
        widget_id: string;
    },
    type: "toggle";
}

export type NumericFieldInputWidget = {
    properties: {
        placeholder: string;
        max: number;
        min: number;
        max_decimal?: number;
        total_max_digits?: number;
        type: "decimal" | "integer";
        uom: string;
        widget_id: string;
    },
    type: "numericfield";
}

export type DateTimeFieldInputWidget = {
    properties: {
        can_pick_future: boolean;
        can_pick_past: boolean;
        default_day_value: "today";
        default_time_value: "now" | "noonUTC";
        widget_id: string;
        type: "dateonly" | "datetime";
    },
    type: "datetimefield";
}

export type LabelDisplayWidget = {
    properties: {
        align?: "center";
        color?: number[];
        size?: number;
        style?: "bold";
        text: string;
    },
    type: "label"
}

export type TextFieldDisplayWidget = {
    properties: {
        align?: "center";
        height?: number;
        size?: number;
        size_to_fit?: "true";
        text_align: "center";
        editable: "false";
        text: string;
    };
    type: "textfield";
}

export type PhotoTakerDisplayWidget = {
    properties: {
        height?: 300;
        image: string;
        width?: 200;
    };
    type: "photo";
}

export type DateTimeFieldDisplayWidget = {
    properties: {
        dateformat: "YYYY-MM-DD" | "YYYY-MM-DDTHH:mm:ss";
        display_local_timezone: boolean;
        display_widget_id: string;
    },
    type: "datetimedisplay";
}

export interface Module {
    _id: string;
    _rev?: string;
    _sync?: any;
    account_id?: string;
    autovalue: {
        defaults: {
            feedback_title?: string;
            status: string;
            value: string;
        },
        handlers: [],
        meta_handler: []
    };
    channels: string[];
    group_ids?: string[];
    groups_ids?: string[];
    last_modified?: string;
    module_id: string;
    module_tag: string;
    module_title: string;
    module_type: string;
    name: string;
    report_content: {
        autosubmit?: string;
        display: string;
        required_fields: string[];
        response_values: {
            [key: string]: string;
        };
        widgets: InputWidgets[];
    };
    single_view: {
        display_values: {} | {
            justRight: "just right",
            veryHot: "very hot"
        };
        widgets: DisplayWidgets[];
    };
    summary: string;
    timestamp: string;
    type: "module";
}